import React from "react";
import ConfirmDialog from "../../../../../components/ConfirmDialog/ConfirmDialog";

const ReminderConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  reminderType,
  loading,
}) => {
  const getHeading = () => {
    return reminderType === "policy"
      ? "Send Policy Reminder"
      : "Send Training Reminder";
  };

  const getContent = () => {
    if (reminderType === "policy") {
      return `Are you sure you want to send policy acknowledgement reminders? This will notify employees who have pending or incomplete policy acknowledgements to complete them.`;
    }
    return `Are you sure you want to send training reminders? This will notify employees who have pending or incomplete training to complete their required training modules.`;
  };

  const getButtonText = () => {
    if (loading) {
      return "Sending...";
    }
    return reminderType === "policy"
      ? "Send Policy Reminder"
      : "Send Training Reminder";
  };

  return (
    <ConfirmDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      heading={getHeading()}
      content={getContent()}
      buttonText={getButtonText()}
      loading={loading}
    />
  );
};

export default ReminderConfirmationDialog;
